import PostCard from './PostCard';
import PostCardActions from './PostCardActions';

export default PostCard;

export { PostCardActions };
